import { loadStripe } from "@stripe/stripe-js";

/**
 * Single shared Stripe instance for the whole app.
 *
 * `loadStripe` must be called once at module scope so Stripe.js (and its fraud
 * beacon at r.stripe.com) is initialised a single time. Previously each payment
 * page called `loadStripe` on its own, which created multiple Stripe instances
 * and fired duplicate beacon requests. Import `stripePromise` from here instead.
 *
 * @type {ReturnType<typeof loadStripe>}
 */
export const stripePromise = loadStripe(`${process.env.REACT_APP_STRIPE_KEY}`);
